// Admin Page Header Component
// Clean header for sub-admin pages with prominent home button
// Supports title, description, and breadcrumbs for enhanced navigation

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AdminPageHeader.css';

export function AdminPageHeader({ title, description, breadcrumbs, icon }) {
  const navigate = useNavigate();

  const handleHomeNavigation = () => {
    navigate('/admin');
  };

  const handleBreadcrumbClick = (path) => {
    if (path) navigate(path);
  };

  return (
    <div className="admin-page-header">
      <div className="admin-page-header-content">
        {/* Home Button */}
        <button
          className="admin-home-button"
          onClick={handleHomeNavigation}
          title="Back to Admin Panel"
          aria-label="Back to Admin Panel"
        >
          <i className="fa-solid fa-arrow-left admin-home-icon"></i>
          <span className="admin-home-text">Admin Panel</span>
        </button>

        {/* Page Title and Info */}
        {(title || description) && (
          <div className="admin-page-info">
            {icon && (
              <div className="admin-page-icon">
                <i className={`fa-solid ${icon}`}></i>
              </div>
            )}
            <div className="admin-page-text">
              {title && <h1 className="admin-page-title">{title}</h1>}
              {description && <p className="admin-page-description">{description}</p>}
            </div>
          </div>
        )}

        {/* Breadcrumbs */}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <div className="admin-breadcrumbs">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={index}>
                {index > 0 && <span className="breadcrumb-separator">/</span>}
                <button
                  className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'current' : ''}`}
                  onClick={() => handleBreadcrumbClick(crumb.path)}
                  disabled={index === breadcrumbs.length - 1 || !crumb.path}
                >
                  {crumb.label}
                </button>
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}